import * as moment from 'moment';

export class CommonHelpers {

    public static SafeDeepClone<T>(target: T): T {
        if (target === undefined) {
        throw new Error('Cannot perform safe clone, target is undefined');
        }
        return (JSON.parse(JSON.stringify(target)) as T);
    }

    public static getBooleanValue(value) {
        if (value == null) {
        return null;
        }
        switch (value.toString().toUpperCase()) {
            case '1':
            case 'ON':
            case 'T':
            case 'TRUE':
            case 'Y':
            case 'YES':
                return true;
            default:
                return false;
        }
    }

    public static isAdult(birthDate: Date): boolean {
        birthDate = new Date(birthDate);
        const birthDateMoment = moment(birthDate);
        const momentNow = moment();
        return momentNow.diff(birthDateMoment, 'years') >= 18;
    }
}
